// extracted by mini-css-extract-plugin
export default {"dialog":"NoShowOverPhone--dialog--381ba8","container":"NoShowOverPhone--container--b279e3","phone":"NoShowOverPhone--phone--556728"};